import { Navbar, Container } from "react-bootstrap";
import ProfileDropdown from "../../../common/ProfileDropdown";
import "./Header.css";

const Header = ({ toggleSidebar, isCollapsed, isMobile }) => {
  // We can pass the menu items we want to show in the dropdown with label, link and icon
  const menuItems = [
    // { label: "Dashboard", link: "/organisation/dashboard", icon: "bi-house" },
    // { label: "Settings", link: "/organisation/settings", icon: "bi-gear" },
    // { label: "Profile", link: "/organisation/profile", icon: "bi-person" },
  ];

  return (
    <Navbar
      className={`header ${isCollapsed && !isMobile ? "sidebar-collapsed" : ""}`}
      expand="lg"
    >
      <Container fluid>
        <div className="header-content">
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            <i className="bi bi-list icon-style"></i>
          </button>
          <div className="navbar-header-right">
            <ProfileDropdown menuItems={menuItems} loginRedirectPath="/login" />
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
